import InquiryDetail from './InquiryDetail'

export default InquiryDetail
